import { c as e } from "../../../../index.esm-BeDSGXP5.js";
import { css as t } from "styled-components";
const l = (o) => o.componentColors.table, a = {
  base: ({ theme: o }) => /* @__PURE__ */ t([
    "",
    " width:100%;border-collapse:collapse;table-layout:fixed;",
    ""
  ], o.resets.space, o.resets.border),
  thead: {
    base: ({ theme: o }) => e({
      backgroundColor: l(o).head.background
    }),
    stacked: ({ theme: o }) => /* @__PURE__ */ t([
      "",
      "{",
      "}"
    ], o.breakpoints.mq.mobileMax, o.components.visuallyHidden)
  },
  tbody: ({ theme: o }) => /* @__PURE__ */ t([
    "tr{border-bottom-width:0.2rem;border-bottom-style:solid;border-bottom-color:",
    ";}"
  ], l(o).row.border),
  tfoot: {
    base: ({ theme: o }) => e({
      backgroundColor: l(o).foot.background
    }),
    stacked: ({ theme: o }) => /* @__PURE__ */ t([
      "",
      "{",
      "}"
    ], o.breakpoints.mq.mobileMax, o.components.visuallyHidden)
  },
  tr: {
    stacked: () => e({
      flexWrap: "wrap",
      alignItems: "center",
      display: [
        "flex",
        null,
        "revert"
      ]
    })
  },
  th: {
    base: () => e({
      boxSizing: "border-box",
      textAlign: "left",
      py: "sm",
      px: "md",
      verticalAlign: "top"
    }),
    stacked: () => e({
      width: "50%",
      display: [
        "revert",
        null,
        "none"
      ],
      py: [
        "sm",
        null,
        null
      ]
    })
  },
  td: {
    base: () => e({
      boxSizing: "border-box",
      textAlign: "left",
      py: "sm",
      px: "md"
    }),
    stacked: () => e({
      width: [
        "50%",
        null,
        "auto"
      ],
      textAlign: [
        "right",
        null,
        "revert"
      ],
      py: [
        "sm",
        null,
        null
      ]
    })
  }
};
export {
  a as default
};
